import { p4Tokens } from '../../styles/themes/default/p4FluentTheme';
import React from 'react';
import { makeStyles, mergeClasses } from '@fluentui/react-components';
import { Circle16Filled, CaretRight16Filled, CaretRight24Filled, ChevronRight16Filled } from '@fluentui/react-icons';
import { useFullUserDetails } from '../../utils/hooks';

export const useStatusCellStyles = makeStyles({
  cell: {
    height: '100%',
    backgroundColor: '#ffffff',
    paddingLeft: '8px',
    paddingRight: '8px',
    fontSize: '13px',
    fontWeight: 400,
    color: '#484644',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    position: 'absolute',
    lineHeight: '36px',
    borderBottom: '1px solid',
    borderBottomColor: p4Tokens.colorNeutralForegroundStaticInverted,
  },
  cellDanger: {
    backgroundColor: p4Tokens.statusFlagDanger,
    color: p4Tokens.colorNeutralForegroundStaticInverted,
  },
  cellWarning: {
    backgroundColor: p4Tokens.statusFlagWarning,
    color: p4Tokens.colorNeutralForegroundStaticInverted,
  },
  cellReady: {
    backgroundColor: p4Tokens.statusFlagReady,
    color: p4Tokens.colorNeutralForegroundStaticInverted,
  },
  cellSuccess: {
    backgroundColor: p4Tokens.statusFlagSuccess,
    color: p4Tokens.colorNeutralForegroundStaticInverted,
  },
  surface: {
    padding: 0,
    opacity: 0.85,
    maxWidth: '900px',
  },
  dangerCircle: {
    color: p4Tokens.statusFlagDanger,
    marginBottom: '-2px',
  },
  warningCircle: {
    color: p4Tokens.statusFlagWarning,
    marginBottom: '-2px',
  },
  readyCircle: {
    color: p4Tokens.statusFlagReady,
    marginBottom: '-2px',
  },
  successCircle: {
    color: p4Tokens.statusFlagSuccess,
    marginBottom: '-2px',
  },
  indentedStatus: {
    paddingLeft: '14px',
  },
});

export const STATUS_CELL_BASIC_HEADER_STYLES: { container: React.CSSProperties; primary: React.CSSProperties } = {
  container: {
    backgroundColor: p4Tokens.colorNeutralBackground4,
    color: p4Tokens.colorNeutralForeground2,
    borderBottomWidth: '1px',
    borderBottomColor: p4Tokens.colorNeutralForeground4,
    borderBottomStyle: 'solid',
    overflow: 'hidden',
  },
  primary: {
    color: p4Tokens.colorNeutralForeground1,
  },
};

export const DragTitle = () => {
  const fullUserDetails = useFullUserDetails();
  const allowSort = fullUserDetails?.companyUser?.allowLineSorting;

  if (!allowSort) {
    return null;
  }
  return 'Select this cell then click, hold & drag to move this row to another position.';
};

export const StatusCircle = ({ message, iconClassName }: { message: string; iconClassName?: string }) => {
  return (
    <div>
      <Circle16Filled className={iconClassName} /> {message}
    </div>
  );
};
